import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './../../styles/admin/productos.css';
import * as globals from './../../components/GlobalScripts.js';
import { useNavigate } from 'react-router-dom';

const Admin_productos = () => {
    let path_api = localStorage.getItem('path_api');
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [productos, setProductos] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        get_productos();
    }, [search, currentPage]);

    const get_productos = async () => {
        globals.validateSession();
        await axios.post(`${path_api}/admin/productos.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            page: currentPage,
            search: search,
            limit: 10
        }).then(response => {
            if (response.data.mensaje === "success") {
                setProductos(response.data.productos);
                setTotalPages(response.data.total_pages);
                setSelectedProducts([]);
            } else if (response.data.mensaje) {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje, effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: "No se obtuvieron los productos", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error 'log-productos-1'", msg: "Si persiste informa al soporte", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleRowClick = (id) => {
        navigate(`/admin/productos/${id}`);
    };

    const handleSelectProduct = (id) => {
        if (selectedProducts.includes(id)) {
            setSelectedProducts(prev => prev.filter(pid => pid !== id));
        } else {
            setSelectedProducts(prev => [...prev, id]);
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            const allIds = productos.map(p => p.id);
            setSelectedProducts(allIds);
        } else {
            setSelectedProducts([]);
        }
    };

    const deleteSelected = async () => {
        if (selectedProducts.length === 0) {
            globals.createAlert({ type: "info", msg_title: "Info", msg: "No hay productos seleccionados para eliminar", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            return;
        }

        globals.validateSession();
        globals.openViewCharge();
        await axios.post(`${path_api}/admin/delete_productos.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            ids: selectedProducts
        }).then(response => {
            if (response.data.mensaje === "success") {
                globals.createAlert({ type: "success", msg_title: "Éxito", msg: "Productos eliminados correctamente", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
                get_productos();
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "Error al eliminar productos", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al eliminar productos", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
        globals.closeViewCharge();
    };

    const calcularInventario = (producto) => {
        let inventario = 0;
        let ilimitado = false;
        try {
            const parsedData = JSON.parse(producto.data);
            const variaciones = Array.isArray(parsedData.variaciones) ? parsedData.variaciones : [];
            for (let v of variaciones) {
                if (v.ilimitado) {
                    ilimitado = true;
                    break;
                } else {
                    inventario += parseInt(v.inventario, 10) || 0;
                }
            }
        } catch {
            inventario = 0;
        }

        return ilimitado ? "Ilimitado" : inventario;
    };

    const contarVariaciones = (producto) => {
        try {
            const parsedData = JSON.parse(producto.data);
            const variaciones = Array.isArray(parsedData.variaciones) ? parsedData.variaciones : [];
            return variaciones.length;
        } catch {
            return 0;
        }
    };

    return (
        <>
            <h2>Listado de productos</h2>

            <div className='container-nav-search'>
                <div>
                    <label>Filtrar</label>
                    <input
                        type="text"
                        placeholder="Escribe para filtrar por nombre, estado o proveedor"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <button onClick={() => navigate(`/admin/productos/new`)}>
                    Agregar Producto
                </button>
                {selectedProducts.length > 0 && (
                    <button onClick={deleteSelected} className='delete-button'>
                        Eliminar ({selectedProducts.length})
                    </button>
                )}
            </div>

            <div className='container-table productos'>
                <table>
                    <thead>
                        <tr>
                            <th style={{maxWidth: "40px"}}><input type="checkbox" onChange={handleSelectAll} checked={selectedProducts.length === productos.length && productos.length > 0} /></th>
                            <th style={{maxWidth: "100px"}}>ID</th>
                            <th>Nombre</th>
                            <th>Estado</th>
                            <th style={{maxWidth: "100px"}}>Variaciones</th>
                            <th style={{maxWidth: "100px"}}>Inventario</th>
                            <th>Proveedor</th>
                        </tr>
                    </thead>
                    <tbody>
                        {productos.map((producto) => {
                            const isSelected = selectedProducts.includes(producto.id);
                            return (
                                <tr key={producto.id} type={producto.estado}>
                                    <td style={{maxWidth: "40px"}}>
                                        <input type="checkbox" checked={isSelected} onChange={() => handleSelectProduct(producto.id)} />
                                    </td>
                                    <td style={{maxWidth: "100px"}} onClick={() => handleRowClick(producto.id)}>{producto.id}</td>
                                    <td onClick={() => handleRowClick(producto.id)}>{producto.nombre}</td>
                                    <td onClick={() => handleRowClick(producto.id)}>{producto.estado}</td>
                                    <td style={{maxWidth: "100px"}} onClick={() => handleRowClick(producto.id)}>{contarVariaciones(producto)}</td>
                                    <td style={{maxWidth: "100px"}} onClick={() => handleRowClick(producto.id)}>{calcularInventario(producto)}</td>
                                    <td onClick={() => handleRowClick(producto.id)}>{producto.proveedor}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                <div className="pagination">
                    <div>
                        <span>Mostrando <b>{productos.length}</b> productos</span>
                    </div>
                    <div>
                        <button onClick={() => changePage(currentPage - 1)} disabled={currentPage === 1}>
                            Anterior
                        </button>
                        <span>Página <b>{currentPage}</b> de <b>{totalPages}</b></span>
                        <button onClick={() => changePage(currentPage + 1)} disabled={currentPage === totalPages}>
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Admin_productos;
